import {extend} from 'flarum/extend';
import Button from "flarum/components/Button";
import TagsPage from "flarum/tags/components/TagsPage";

export default function () {
  if (TagsPage) {
    extend(TagsPage.prototype, 'view', function (original) {
      // The button should only be added while the user is not logged in.
      if (!app.session.user) {
        const wrapper = m('div', {className: "EmuResponsLoginButton"}, [
          Button.component({
            className: 'EmuResponsButton',
            onclick: () => window.location.replace(`${app.forum.attribute('baseUrl')}/auth/unilogin`)
          }, app.translator.trans('auth-unilogin.forum.login.login_button')),
          m('p', {}, app.translator.trans('auth-unilogin.forum.login.explainer'))
        ]);
        original.children.push(wrapper);
      }
    });
  }
}
